/**
 * Created by jv on 24/07/2017.
 */
import Tab from './tab';
import Collapse from './collapse';
import Dropdown from './dropdown';
import Modal from './modal';
import Tooltip from './tooltip';
import Popover from './popover';

export default {
  Tab,
  Collapse,
  Dropdown,
  Modal,
  Tooltip,
  Popover
}



// WEBPACK FOOTER //
// ./app/libs/bootstrap/js/bootstrap.js